/* AVRA_BAG_COPY (2026-10-10, Brandon)
   Bag drawer copy, layered on top of the drawer that assets/avra-theme.js
   builds (that file is ~63KB, so these two lines live here instead):
   1. The suggestions heading reads "Complete the Look" (was "Pairs beautifully"),
      matching the product page.
   2. A "Made to order  2-5 weeks" row sits under Subtotal / Shipping.
   Runs every time the drawer re-renders (qty change, remove, add). */
(function () {
  'use strict';
  var HEADING = 'Complete the Look';
  var MTO_LABEL = 'Made to order';
  var MTO_VALUE = '2–5 weeks';

  function patch(root) {
    var h = root.querySelectorAll('.bagrecs__h');
    for (var i = 0; i < h.length; i++) {
      if (h[i].textContent !== HEADING) h[i].textContent = HEADING;
    }
    var sums = root.querySelectorAll('.bagsum');
    for (var j = 0; j < sums.length; j++) {
      var sum = sums[j];
      if (sum.querySelector('.bagsum__row--mto')) continue;
      var row = document.createElement('div');
      row.className = 'bagsum__row bagsum__row--mto';
      row.innerHTML = '<span></span><span></span>';
      row.children[0].textContent = MTO_LABEL;
      row.children[1].textContent = MTO_VALUE;
      sum.appendChild(row);
    }
  }

  function init() {
    var drawer = document.querySelector('[data-bag-drawer]') || document.body;
    patch(drawer);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () { patch(drawer); })
      .observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
